import { Component, HostListener, OnInit, ViewChild } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  public documentId: string;
  public fileType: string;
  public token: string;
  public dmsuser: string;
  public sfdcbaseurl: string;

  constructor(
    route: ActivatedRoute,
    sanitizer: DomSanitizer,
    public router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    let href = window.location.href;
    let url = new URL(window.location.href);
    this.documentId = url.searchParams.get('documentId');
    this.fileType = url.searchParams.get('fileType');
    if (localStorage.getItem('docId') === null) {
      localStorage.setItem('docId', this.documentId);
    }
    if (localStorage.getItem('fileType') === null) {
      localStorage.setItem('fileType', this.fileType);
    }
    // this.token = url.searchParams.get('token');
    // this.dmsuser = url.searchParams.get('dms-user');
    // this.sfdcbaseurl = url.searchParams.get('sfdcbaseurl');
    if (href.includes('guest')) {
      this.router.navigate(['/guest-user'], {
        queryParams: { documentId: this.documentId, fileType: this.fileType },
      });
    } else if (href.includes('public')) {
      this.router.navigate(['/public-user'], {
        queryParams: { documentId: this.documentId, fileType: this.fileType },
      });
    } else {
      this.login();
    }
    // this.authenticationService.validateSession(this.sfdcbaseurl, this.token).then(res => {
    //   this.router.navigate(['/login-user'], { queryParams: { documentId: this.documentId, fileType: this.fileType, userName: this.dmsuser} });
    // }).catch(err => {
    //   console.log(err);
    // })
  }

  login() {
    let userObj = null;
    userObj = localStorage.getItem('currentUser');
    if (userObj == null) {
      const location: string = window.location.href;
      let token = undefined;
      if (location.includes('?code=')) {
        token = location.substring(location.indexOf('?code=') + 6);
      }
      if (token) {
        this.router.navigate(['/ssologin'], { queryParams: { code: token } });
      } else {
        this.router.navigate(['/ssologin'], {
          queryParams: { documentId: this.documentId, fileType: this.fileType },
        });
      }
    } else {
      let user = JSON.parse(userObj);
      this.router.navigate(['/login-user'], {
        queryParams: {
          documentId: this.documentId,
          fileType: this.fileType,
          userName: user['username'],
        },
      });
    }
  }

  // To clear cache during browser close
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    if (localStorage.getItem('isDocLoad')) {
      localStorage.clear();
    }
  }
}
